import React from "react";
import env from "../../env/env.json";

const LogoVille = () => {
  // ** toujours renommer le fichier image en logo-ville.png toujours avec les même dimensions et le placer dans le dossier img */
  const logo = env.logo;
  return (
    <div className="mb-5 d-flex flex-column">
      <img className="logo mb-1" src={logo} alt="logo ville" width={220} />
    </div>
  );
};

export default LogoVille;
